import PublicIcon from "@mui/icons-material/Public"
import TrafficIcon from "@mui/icons-material/Traffic"
import VisibilityIcon from "@mui/icons-material/Visibility"
import { useContext } from "react"
import { MapContext } from "../MapContextProvider"
import { StyledDiv, StyledIconButton } from "./MapLayerIcons.styled"

const MapLayerIcons = () => {
  const { setMapType } = useContext(MapContext)

  return (
    <StyledDiv>
      <StyledIconButton
        edge="start"
        color="inherit"
        aria-label="menu"
        onClick={() => setMapType("satellite")}>
        <PublicIcon fontSize="medium" />
      </StyledIconButton>
      <StyledIconButton edge="start" color="inherit" aria-label="menu" onClick={() => setMapType("hybrid")}>
        <TrafficIcon fontSize="medium" />
      </StyledIconButton>
      <StyledIconButton edge="start" color="inherit" aria-label="menu" onClick={() => setMapType("roadmap")}>
        <VisibilityIcon fontSize="medium" />
      </StyledIconButton>
    </StyledDiv>
  )
}

export default MapLayerIcons
